var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDangerTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42638 8.96791C6.85835 4.65597 8.07434 2.5 9.99996 2.5C11.9256 2.5 13.1416 4.65597 15.5735 8.96791L15.8766 9.50522C17.8975 13.0884 18.908 14.88 17.9947 16.19C17.0815 17.5 14.822 17.5 10.303 17.5H9.69691C5.17793 17.5 2.91844 17.5 2.00517 16.19C1.09191 14.88 2.10239 13.0884 4.12334 9.50523L4.42638 8.96791ZM9.99996 6.04167C10.3451 6.04167 10.625 6.32149 10.625 6.66667V10.8333C10.625 11.1785 10.3451 11.4583 9.99996 11.4583C9.65478 11.4583 9.37496 11.1785 9.37496 10.8333V6.66667C9.37496 6.32149 9.65478 6.04167 9.99996 6.04167ZM9.99996 14.1667C10.4602 14.1667 10.8333 13.7936 10.8333 13.3333C10.8333 12.8731 10.4602 12.5 9.99996 12.5C9.53972 12.5 9.16663 12.8731 9.16663 13.3333C9.16663 13.7936 9.53972 14.1667 9.99996 14.1667Z",
    fill: "#F2302F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerTriangle);
export default __webpack_public_path__ + "static/media/dangerTriangle.af6503e690af067790d9d2e849020e90.svg";
export { ForwardRef as ReactComponent };